export default __webpack_public_path__ + "static/media/smokehouse-special-banner.bbd7cc02.jpg";